/**
 * Asynchronously loads the Checkout page (mobile / fixed / activation router).
 */
import { lazyLoad } from "utils/loadable";

export const Checkout = lazyLoad(
  () => import("./index"),
  (module) => module.Checkout
);
